import React from "react";
import BotonDivL from "../../../../components/Boton/BotonDivL";
import { Button, Modal } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { startNoProcedente } from "../../../../context/actions/asignacionActions";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { DatosEsNoProcedente } from "./DatosEsNoProcedente";
import LabelSelect from "../../../../components/select/LabelSelect";
import { motivosNoProcedente } from "../../../../constants/cons";

export const NoProcede = () => {
  const dispatch = useDispatch();
  const {esNoProcedente} = useSelector(state => state.asistenciasReducer.asistencia);
  const [open, setOpen] = React.useState(false);
  const {asistenciaID} = useParams()
  const [motivoNoProcedente, setMotivoNoProcedente] = React.useState("");
  const submit = () => 
  {
      dispatch(startNoProcedente({motivoNoProcedente, asistenciaID}));
      setOpen(false);
  }

  if(esNoProcedente)
    return <DatosEsNoProcedente />

  return (
    <>
      <BotonDivL tituloBoton="No Procede" onClick={() => setOpen(true)} />
      <Modal
        width={650}
        title={
          <span>
            <CloseCircleOutlined style={{ color: '#ff4d4f', marginRight: 8 }} />
            No procede
          </span>
        }
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setOpen(false)} size="middle">
            Cancelar
          </Button>,
          <Button
            key="submit"
            onClick={submit}
            disabled={!motivoNoProcedente}
            type="primary"
            size="middle"
          >
            Confirmar No Procede
          </Button>,
        ]}
        open={open}
      >
        <div style={{ padding: '8px 0 16px 0' }}>
          <LabelSelect
            label="Por favor indica el motivo"
            name="motivoNoProcedente"
            value={motivoNoProcedente}
            onChange={(val) => setMotivoNoProcedente(val)}
            opciones={motivosNoProcedente}
            placeholder="Selecciona un motivo..."
          />
        </div>
      </Modal>
    </>
  );
};
